import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Box } from '@mui/material';


const posts = [
  {
    title: 'How to Resell Internet in Kenya',
    description: 'A beginner-friendly guide to starting an internet reselling business in Kenya, including equipment, billing, and legal requirements.',
    imageURL: '/images/reselling-internet.png', // Replace with actual blog image
    slug: 'how-to-resell-internet-in-kenya',
  },
  // {
  //   title: 'Best Mikrotik Routers for Internet Reselling',
  //   description: 'Explore the most reliable and cost-effective Mikrotik routers suited for small ISPs and internet resellers.',
  //   imageURL: 'https://via.placeholder.com/300', // Replace with actual blog image
  //   slug: 'best-mikrotik-routers-for-internet-reselling',
  // },
  // {
  //   title: 'Setting Up PPPoE Authentication on Mikrotik',
  //   description: 'Step-by-step instructions to configure PPPoE authentication on Mikrotik and integrate with a RADIUS server.',
  //   imageURL: 'https://via.placeholder.com/300', // Replace with actual blog image
  //   slug: 'setup-pppoe-authentication-on-mikrotik',
  // },
  {
    title: 'Introduction to NasRadius',
    description: 'Learn how NasRadius revolutionizes ISP billing, user management, and remote Mikrotik router control.',
    imageURL: '/images/desktop-dashboard.png', // Replace with your image URL
    slug: 'what-is-nasradius',
  },
  // {
  //   title: 'What is RouterOS and Why It Matters',
  //   description: 'Understand the powerful features of RouterOS and why it’s essential for managing Mikrotik routers in ISP setups.',
  //   imageURL: 'https://via.placeholder.com/300', // Replace with actual blog image
  //   slug: 'what-is-routeros',
  // },
  // {
  //   title: 'Remote Access to Mikrotik with NasRadius',
  //   description: 'Securely access and manage Mikrotik routers remotely using NasRadius, VPN, or WireGuard on RouterOS v7+.',
  //   imageURL: 'https://via.placeholder.com/300', // Replace with actual blog image
  //   slug: 'remote-access-to-mikrotik-with-nasradius',
  // },
  {
    title: 'Load Balancing and Failover on Mikrotik using PCC',
    description: 'Comprehensive guide to configuring per connection classifier (PCC) for load balancing and failover on RouterOS 7.',
    imageURL: '/images/load-balancing.png', // Replace with actual blog image
    slug: 'load-balance-two-internet-links-on-mikrotik',
  }, 
  {
    title: 'Best Mikrotik Routers for Internet Reselling in Kenya',
    description: 'Explore the most reliable and cost-effective Mikrotik routers suited for small ISPs and internet resellers.',
    imageURL: '/images/mikrotik-routers.png', // Replace with actual blog image
    slug: 'best-mikrotik-routers-for-internet-reselling-in-kenya',
  }
];


const BlogPage = () => {
  return (
    <Box
      component="section"
      id="blog"
      sx={{
        padding: { xs: '40px 16px', sm: '60px 24px', md: '80px 32px' },
        backgroundColor: '#f9f9f9',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          gutterBottom
          sx={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
            fontWeight: 600,
            color: '#2C3E50',
            marginBottom: '40px',
          }}
        >
          Blog Articles
        </Typography>
        <Grid container spacing={4}>
          {posts.map((post, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.2)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="140"
                  image={post.imageURL}
                  alt={post.title}
                />
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                      fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
                      fontWeight: 600,
                      color: '#0b74c1',
                      marginBottom: '10px',
                      transition: 'color 0.3s ease',
                      '&:hover': {
                        color: '#19b594',
                      },
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
                      color: '#555',
                      marginBottom: '10px',
                    }}
                  >
                    {post.description}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
                      color: '#0b74c1',
                      cursor: 'pointer',
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                    }}
                    onClick={() => (window.location.href = `/blog/${post.slug}`)}
                  >
                    Read More
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BlogPage;